import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogsRequest, deleteBlogRequest } from "../redux/actions/blogActions";
import { useNavigate } from "react-router-dom";
import "../styles/Blogs.css"; // Ensure the file exists and contains the CSS

const stripHtmlTags = (htmlContent) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  return doc.body.textContent || "";
};

const BlogList = ({ user_id }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { blogs = [], loading, error, hasMore, currentPage } = useSelector(
    (state) => state.blogs
  );

  useEffect(() => {
    dispatch(fetchBlogsRequest({ user_id, currentPage }));
    scrollToTop();
  }, [dispatch, user_id, currentPage]);

  const scrollToTop = () =>{
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
  const loadNextPage = () => {
    if (hasMore && !loading) {
      dispatch(fetchBlogsRequest({ user_id, currentPage: currentPage + 1 }));
      scrollToTop();
    }
  };

  const loadPreviousPage = () => {
    if (currentPage > 1 && !loading) {
      dispatch(fetchBlogsRequest({ user_id, currentPage: currentPage - 1 }));
      scrollToTop();
    }
  };

  const handleEdit = (blog) => {
    navigate(`/blogEditor/${blog.id}`, { state: { blog } });
  };

  const handleDelete = async (blogId) => {
    const confirmed = window.confirm("Are you sure you want to delete this blog?");
    if (confirmed) {
      //dispatch(deleteBlogRequest(blogId)); // Dispatch the delete action
      try {
        dispatch(deleteBlogRequest(blogId))
        
      } catch (error) {
        // Silently catch the error without showing it
      } finally {
        
      }
    }
  };

  const handleContinueReading = (blog) => {
    navigate(`/blogs/${blog.id}`, { state: { blog } });
  };


  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4 text-center">
        {user_id ? "My Blogs" : "All Blogs"}
      </h1>

      {user_id ? (
        blogs.length === 0 ? (
          <>
          <p>You have not written any blogs yet, or they are not approved yet. Contact site administrator</p>
          <p className="blogwrite">  <a href="/blogEditor"> <i className="fa-solid fa-edit"></i>Click here to write a blog</a></p>
          </>
          
        ) : (
          <>
          
          <p className="blogwrite p-3">  <a href="/blogEditor"> <i className="fa-solid fa-edit"></i>Click here to write a blog</a></p>
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b font-semibold text-left">Title</th>
                <th className="py-2 px-4 border-b font-semibold text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {blogs.map((blog) => (
                <tr key={blog.id}>
                  <td className="py-2 px-4 border-b">{blog.title}</td>
                  <td className="py-2 px-4 border-b text-center space-x-4">
                    <button
                      onClick={() => handleEdit(blog)}
                      className="text-blue-500 hover:text-blue-700"
                      title="Edit"
                    >
                      <i className="fa-solid fa-edit"></i>
                    </button>
                    <button
                      onClick={() => handleDelete(blog.id)}
                      className="text-red-500 hover:text-red-700"
                      title="Delete"
                    >
                      <i className="fa-solid fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </>
        )
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {loading
            ? Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="border rounded-lg shadow-lg overflow-hidden">
                  <div className="shimmer h-48 w-full rounded-t-lg"></div>
                  <div className="p-4">
                    <div className="shimmer h-6 mb-4 w-3/4"></div>
                    <div className="shimmer h-4 mb-4 w-1/2"></div>
                    <div className="shimmer h-4 w-1/2"></div>
                  </div>
                </div>
              ))
            : blogs.map((blog, index) => (
                <article
                  key={index}
                  className="border rounded-lg shadow-lg overflow-hidden"
                >
                  <div className="t4s-post-inner">
                    <div className="t4s-post-thumb relative pt-[68.5%] overflow-hidden bg-gray-200">
                      <a href={blog.url} className="absolute inset-0 w-full h-full">
                        <img
                          src={blog.image}
                          alt={blog.title}
                          className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                        />
                      </a>
                    </div>

                    <div className="p-4">
                      <h3 className="text-xl font-semibold mb-2">
                        <a
                          href="#"
                          onClick={() => handleContinueReading(blog)}
                          className="text-gray-900 hover:underline"
                        >
                          {blog.title}
                        </a>
                      </h3>

                      <p className="text-gray-700 mb-4">
                        {stripHtmlTags(blog.content).slice(0, 100)}...
                      </p>

                      <button
                        onClick={() => handleContinueReading(blog)}
                        className="block underline text-blue-600 hover:text-blue-800"
                      >
                        Continue Reading
                      </button>
                    </div>
                  </div>
                </article>
              ))}
        </div>
      )}
      
      {blogs.length > 0 && (
        <div className="flex justify-between items-center mt-6">
          <button
            onClick={loadPreviousPage}
            disabled={loading || currentPage === 1}
            className="bg-gray-700 text-white font-semibold py-2 px-4 rounded disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            Previous
          </button>
          <button
            onClick={loadNextPage}
            disabled={loading || !hasMore}
            className="bg-gray-700 text-white font-semibold py-2 px-4 rounded disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
      )}
    </div>

      
  );
};

export default BlogList;
